import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'keys',
    standalone: false
})
export class KeysPipe implements PipeTransform {
  transform(value: Record<string, any>, args: string[]): any {
    const keys: { key: string; value: any; displayName: string }[] = [];
    for (const enumMember in value) {
      if (!isNaN(parseInt(enumMember, 10))) {
        if (value[enumMember] !== 'Unknown') {
          keys.push({key: enumMember,
            value: value[enumMember],
            displayName: value[enumMember].split(/(?=[A-Z])/).join(' ')});
        }
      }
    }
    return keys;
  }
}
